// extracted by mini-css-extract-plugin
module.exports = {"organisation":"styles_organisation__kNjNi"};